import { render, staticRenderFns } from "./ServiceProposalTokenHistory.vue?vue&type=template&id=2d852bd1&scoped=true"
import script from "./ServiceProposalTokenHistory.vue?vue&type=script&lang=js"
export * from "./ServiceProposalTokenHistory.vue?vue&type=script&lang=js"
import style0 from "./ServiceProposalTokenHistory.vue?vue&type=style&index=0&id=2d852bd1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d852bd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d852bd1')) {
      api.createRecord('2d852bd1', component.options)
    } else {
      api.reload('2d852bd1', component.options)
    }
    module.hot.accept("./ServiceProposalTokenHistory.vue?vue&type=template&id=2d852bd1&scoped=true", function () {
      api.rerender('2d852bd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/ServiceProposalTokenHistory.vue"
export default component.exports